module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-ttl",
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split4#title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split5#copy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/9781617750502_Split9#ch1",
      "id": "toc1"
    }
  }, [_vm._v("2009")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/9781617750502_Split9#ch2",
      "id": "toc2"
    }
  }, [_vm._v("HOME (new introduction)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/9781617750502_Split10#ch3",
      "id": "toc3"
    }
  }, [_vm._v("1965")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/9781617750502_Split10#ch4",
      "id": "toc4"
    }
  }, [_vm._v("HOME (original introduction)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/9781617750502_Split11#ch5",
      "id": "toc5"
    }
  }, [_vm._v("1960")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/9781617750502_Split11#ch6",
      "id": "toc6"
    }
  }, [_vm._v("Cuba Libre")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split12#ch7",
      "id": "toc7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1961")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split12#ch8",
      "id": "toc8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Jules Feiffer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split13#ch9",
      "id": "toc9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1962")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split13#ch10",
      "id": "toc10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tokenism: 300 Years for Five Cents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split14#ch11",
      "id": "toc11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Black” Is a Country")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split15#ch12",
      "id": "toc12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("City of Harlem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split16#ch13",
      "id": "toc13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cold, Hurt, and Sorrow (Streets of Despair)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split17#ch14",
      "id": "toc14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Street Protest")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split18#ch15",
      "id": "toc15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soul Food")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split19#ch16",
      "id": "toc16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Myth of a “Negro Literature”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split20#ch17",
      "id": "toc17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1963")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split20#ch18",
      "id": "toc18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brief Reflections on Two Hot Shots")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split21#ch19",
      "id": "toc19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Dark Bag")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split22#ch20",
      "id": "toc20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Does Nonviolence Mean?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split23#ch21",
      "id": "toc21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dempsey-Liston Fight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split24#ch22",
      "id": "toc22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black Writing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split25#ch23",
      "id": "toc23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Expressive Language")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split26#ch24",
      "id": "toc24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1964")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split26#ch25",
      "id": "toc25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hunting Is Not Those Heads on the Wall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split27#ch26",
      "id": "toc26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LeRoi Jones Talking")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split28#ch27",
      "id": "toc27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Days of the American Empire (Including Some Instructions for Black People)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split29#ch28",
      "id": "toc28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Revolutionary Theatre")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split30#ch29",
      "id": "toc29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1965")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split30#ch30",
      "id": "toc30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("American Sexual Reference: Black Male")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split31#ch31",
      "id": "toc31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blackhope")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split32#ch32",
      "id": "toc32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Legacy of Malcolm X, and the Coming of the Black Nation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/9781617750502_Split33#ch33",
      "id": "toc33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STATE/MEANT")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58fdd905","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781617750502_Split8.vue
// module id = 81
// module chunks = 0